import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { Suspense } from "react";
import PageTransition from "./components/feature/PageTransition";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import VisitorTracking from "./components/feature/VisitorTracking";
import { SiteConfigProvider } from "./contexts/SiteConfigContext";

function App() {
  return (
    <SiteConfigProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <PageTransition />
          <VisitorTracking />
          <WhatsAppButton />
          <Suspense fallback={<div className="min-h-screen" />}>
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </I18nextProvider>
    </SiteConfigProvider>
  );
}

export default App;
